module.exports = __webpack_public_path__ + "img/2-1.f1e03906.png";